module.exports = __webpack_public_path__ + "static/media/Translations_white.300514cf.svg";